<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[headerIcon]="data?.simUser ? {fontSet: 'fad', fontIcon: 'fa-user-edit'} : {fontSet: 'fad', fontIcon: 'fa-user-plus'}"
	[headerText]="(data?.simUser ? 'EDIT_SIM_USER_DIALOG_TXT' : 'CREATE_SIM_USER_DIALOG_TXT') | translate"
	[matDialogData]="data"
	[rect]="rect"
>
	<ng-container dialogContent>
		<form [formGroup]="createUserFormGroup">
			<div class="formFieldRow oneColFieldWrapper">
				<mat-form-field *ngVar="createUserFormGroup.get('username') as username" class="full-width-form" color="accent">
					<mat-label>{{ T.CREATE_SIM_USER_DIALOG_ENTER_USERNAME | translate }}</mat-label>
					<input formControlName="username" matInput placeholder="max" />
					@if (username.invalid && !username.hasError("spaceNotAllowed")) {
						<mat-error>{{ T.CREATE_USER_DIALOG_ENTER_USERNAME | translate }} </mat-error>
					}
					@if (username.hasError("spaceNotAllowed")) {
						<mat-error>{{ T.CREATE_USER_DIALOG_WITHOUT_SPACE_HINT | translate }}</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="formFieldRow oneColFieldWrapper">
				<mat-form-field *ngVar="createUserFormGroup.get('email') as email" class="full-width-form" color="accent">
					<mat-label>
						<mat-icon fontIcon="fa-at" fontSet="fad" inline />
						{{ T.CREATE_USER_DIALOG_ENTER_EMAIL | translate }}
					</mat-label>
					<input formControlName="email" matInput placeholder="max@simstation.com" />
					@if (email.invalid && !email.hasError("spaceNotAllowed")) {
						<mat-error>{{ T.CREATE_USER_DIALOG_ENTER_VALID_EMAIL_HINT | translate }} </mat-error>
					}
					@if (email.hasError("spaceNotAllowed")) {
						<mat-error>{{ T.CREATE_USER_DIALOG_ENTER_WITHOUT_SPACES_HINT | translate }}</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="formFieldRow twoColFieldWrapper">
				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.CREATE_USER_DIALOG_ENTER_FIRSTNAME_LABEL | translate }}</mat-label>
					<input formControlName="firstName" matInput placeholder="Max" />
					@if (createUserFormGroup.get("firstName").invalid) {
						<mat-error>{{ T.CREATE_USER_DIALOG_FIRSTNAME_ERROR_REQUIRED | translate }} </mat-error>
					}
				</mat-form-field>

				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.CREATE_USER_DIALOG_ENTER_YOUR_LASTNAME_LABEL | translate }}</mat-label>
					<input formControlName="lastName" matInput placeholder="Mustermann" />
					@if (createUserFormGroup.get("lastName").invalid) {
						<mat-error>{{ T.CREATE_USER_DIALOG_LASTNAME_REQUIRED_ERROR | translate }} </mat-error>
					}
				</mat-form-field>
			</div>

			<form [formGroup]="passwordFormGroup">
				@if (!data.simUser) {
					<div class="formFieldRow oneColFieldWrapper">
						<mat-form-field class="full-width-form" color="accent" style="margin-bottom: 10px">
							<mat-label>
								<mat-icon fontIcon="fa-key" fontSet="fad" inline />
								{{ T.CREATE_USER_DIALOG_NEW_PASSWORD_LABEL | translate }}
							</mat-label>
							<button
								(click)="hidePasswordNew = !hidePasswordNew"
								[attr.aria-label]="'Hide password'"
								[attr.aria-pressed]="hidePasswordNew"
								mat-icon-button
								matSuffix
							>
								@if (hidePasswordNew) {
									<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
								}
								@if (!hidePasswordNew) {
									<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
								}
							</button>
							<input [type]="hidePasswordNew ? 'password' : 'text'" autocomplete="off" formControlName="password" matInput />
							@if (passwordFormGroup.get("password").hasError("invalidPwdLength")) {
								<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_LENGTH | translate }} </mat-error>
							}
							@if (passwordFormGroup.get("password").hasError("required")) {
								<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_REQUIRED | translate }} </mat-error>
							}
							@if (passwordFormGroup.get("password").hasError("noLowerCaseChar")) {
								<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_NO_LOWER_CASE | translate }} </mat-error>
							}
							@if (passwordFormGroup.get("password").hasError("noUpperCaseChar")) {
								<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_NO_UPPER | translate }} </mat-error>
							}
							@if (passwordFormGroup.get("password").hasError("noNumbers")) {
								<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_HINT_NO_NUMBERS | translate }} </mat-error>
							}
						</mat-form-field>
					</div>
				}

				@if (!data.simUser) {
					<div class="formFieldRow oneColFieldWrapper">
						<mat-form-field class="full-width-form" color="accent">
							<mat-label>
								<mat-icon fontIcon="fa-key" fontSet="fad" inline />
								{{ T.CHANGE_USER_PASSWORD_DIALOG_CONFIRM_NEW_PASSWORD | translate }}
							</mat-label>
							<button
								(click)="hidePasswordNew = !hidePasswordNew"
								[attr.aria-label]="'Hide password'"
								[attr.aria-pressed]="hidePasswordNew"
								mat-icon-button
								matSuffix
							>
								@if (hidePasswordNew) {
									<mat-icon fontIcon="fa-eye-slash" fontSet="fas" inline style="font-size: 0.8em" />
								}
								@if (!hidePasswordNew) {
									<mat-icon fontIcon="fa-eye" fontSet="far" inline style="font-size: 0.8em" />
								}
							</button>
							<input
								[type]="hidePasswordNew ? 'password' : 'text'"
								autocomplete="off"
								formControlName="confirmPassword"
								matInput
							/>
							@if (passwordFormGroup.get("confirmPassword").hasError("passwordMismatch")) {
								<mat-error>{{ T.CHANGE_USER_PASSWORD_DIALOG_PASSWORDS_DO_NOT_MATCH | translate }} </mat-error>
							}
						</mat-form-field>
					</div>
				}
			</form>

			<div class="formFieldRow oneColFieldWrapper">
				<mat-radio-group formControlName="gender">
					<mat-radio-button [value]="0">{{ T.GLOBAL_TEXT_MALE | translate }}</mat-radio-button>
					<mat-radio-button [value]="1">{{ T.GLOBAL_TEXT_FEMALE | translate }}</mat-radio-button>
					<mat-radio-button [value]="2">{{ T.GLOBAL_TEXT_OTHER_GENDER | translate }}</mat-radio-button>
				</mat-radio-group>
			</div>

			<div class="formFieldRow oneColFieldWrapper">
				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.CREATE_USER_ENTER_BIRTHDAY_LABEL | translate }}</mat-label>
					<input (focusin)="datepicker.open()" [matDatepicker]="datepicker" formControlName="birthDay" matInput />
					@if (createUserFormGroup.get("birthDay")?.invalid) {
						<mat-error>{{ T.CREATE_USER_BIRTHDAY_NOT_VALID | translate }}</mat-error>
					}
					<mat-datepicker-toggle [for]="datepicker" matSuffix />
					<mat-datepicker #datepicker color="accent">
						<mat-datepicker-actions>
							<button color="warn" mat-button matDatepickerCancel>{{ T.GLOBAL_TEXT_CANCEL | translate }}</button>
							<button color="accent" mat-raised-button matDatepickerApply>{{ T.BUTTON_OK | translate }}</button>
						</mat-datepicker-actions>
					</mat-datepicker>
				</mat-form-field>
			</div>

			<div class="formFieldRow twoColFieldWrapper">
				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.CREATE_USER_CONTACT_NO | translate }}</mat-label>
					<input formControlName="contactNumber" matInput />
				</mat-form-field>

				<mat-form-field class="full-width-form" color="accent">
					<mat-label>{{ T.CREATE_USER_STUDENT_ID_LABEL | translate }}</mat-label>
					<input formControlName="studentId" matInput />
				</mat-form-field>
			</div>

			<div class="formFieldRow">
				<div class="formFieldRow">
					<section>
						<div class="mat-h2 checklistRoleHeader">{{ T.CREATE_USER_ROLE_TO_BE_SET_BY_ADMIN_HINT | translate }}</div>
						<div class="checklistOptions">
							@for (role of simRole; track role; let even = $even; let odd = $odd; let last = $last) {
								@if (
									!(
										role.id === "Technician" &&
										currentUser?.roleIds.includes("Admin") &&
										!currentUser?.roleIds.includes("Technician")
									)
								) {
									<div class="checklistRow">
										<p>
											<mat-checkbox
												(change)="roleChanged(role.id, $event)"
												[checked]="data?.simUser?.roleIds?.includes(role.id)"
											>
												{{ role.name }}
											</mat-checkbox>
										</p>
									</div>
								}
							}
						</div>
					</section>
				</div>
			</div>
		</form>
	</ng-container>

	<ng-container actions>
		@if (data.simUser && permissionToChangeAllPassword) {
			<sim-button
				[disabled]="data?.simUser?.loginType != LoginType.Local"
				(onClick)="changePasswordClicked()"
				[color]="'accent'"
				[icon]="{fontSet: 'fad', fontIcon: 'fa-key'}"
				[label]="T.USER_CHANGE_PASSWORD"
				style="margin-right: 12px"
			/>
		}

		@if (updateUserPermission) {
			<sim-button
				(onClick)="okClicked()"
				[color]="'accent'"
				[disabled]="
					(data?.simUser?.loginType ?? LoginType.Local) !== LoginType.Local ||
					(!!data.simUser ? createUserFormGroup.invalid : createUserFormGroup.invalid || passwordFormGroup.invalid)
				"
				[icon]="{
					fontSet: 'fad',
					fontIcon: data.simUser ? 'fa-user-edit' : 'fa-user-plus',
				}"
				[label]="data.simUser ? T.UPDATE_USER_TXT : T.CREATE_USER_TXT"
			/>
		}
	</ng-container>
</sim-basic-material-dialog>
